import { render, staticRenderFns } from "./ProductListManage.vue?vue&type=template&id=a87e5494&scoped=true"
import script from "./ProductListManage.vue?vue&type=script&lang=js"
export * from "./ProductListManage.vue?vue&type=script&lang=js"
import style0 from "./ProductListManage.vue?vue&type=style&index=0&id=a87e5494&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87e5494",
  null
  
)

export default component.exports